// src/services/Pdf.js
import jsPDF from 'jspdf';
import Api from '../../services/Api'
import logoPrefeitura from '../../../src/imagens/prefeitura_ouro_preto_logo_1.png'
import logoGente from '../../../src/imagens/20191205 - Logo GENTE.png'
class PdfInitialPage {
  static async gerarRelatorio(distrito, natureza, prodAgropecImage, mapImage, imovelImage) {
    const propCadastrada = await Api.getPropCadastrada(distrito);
    const propProduzindo = await Api.getPropProduzindo(distrito);
    const propNaoProduzindo = await Api.getPropNProduzindo(distrito);
    const doc = new jsPDF();

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    // Considerações Iniciais
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text('Considerações iniciais', 10, 40)
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    const consideracoes = `      As informações e dados contidas no presente relatório foram extraídas através do dashboard oficial do Censo Agropecuário de Ouro Preto – MG. O Censo Agropecuário foi uma das principais etapas do Plano Municipal de Desenvolvimento Rural de Ouro Preto, projeto desenvolvido pela Secretaria Municipal de Agropecuária em parceria com a Universidade Federal de Viçosa. O objetivo central do Censo Agropecuário consistiu na busca de informações sobre os estabelecimentos e as atividades agropecuárias, caracterizando o produtor e o estabelecimento, a economia e emprego no meio rural, a pecuária, a lavoura e a agroindústria. Todo o processo foi realizado a partir da aplicação do Boletim de Cadastro Rural (BCR), formulário estruturado para caracterizar as propriedades, a infraestrutura rural, as condições socioeconômicas dos produtores e as atividades desenvolvidas. A seguir serão sintetizados alguns dados do Censo Agropecuário em formas de tabelas, gráficos e mapas.`;
    doc.text(consideracoes, 10, 50, { maxWidth: 180, align: 'justify' });

    // Lista de condições e filtros
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Lista de condições e filtros aplicados", 10, 110);

    let y = 120;
    const filtros = [
      ["Distrito:", distrito || 'Não informado'],
      ["Natureza de Produção: ", natureza || 'Todas']
    ];

    doc.setFontSize(12);

    filtros.forEach(([label, valor]) => {
      // Marcador
      doc.setFont("helvetica", "normal");
      doc.text("\u2022", 10, y);

      // Label em negrito
      doc.setFont("helvetica", "bold");
      doc.text(label, 15, y);

      doc.setFont("helvetica", "normal");
      doc.text(String(valor), 15 + doc.getTextWidth(label) + 5, y);

      y += 6;
    });

    y+=5;
    // Indicadores
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Informações Gerais", 10, y);
    y += 10;

    const indicadores = [
      ["Propriedades cadastradas:   ", propCadastrada.value],
      ["Propriedades com produção:   ", propProduzindo.value],
      ["Propriedades sem produção:   ", propNaoProduzindo.value],
    ];

    doc.setFontSize(12);

    indicadores.forEach(([label, valor]) => {
      doc.setFont("helvetica", "normal");
      doc.text("\u2022", 10, y);

      doc.setFont("helvetica", "bold");
      doc.text(label, 15, y);

      doc.setFont("helvetica", "normal");
      doc.text(String(valor), 15 + doc.getTextWidth(label) + 2, y);

      y += 6;
    });

    y +=5;
    doc.addImage(prodAgropecImage, 'PNG', 20, y, 180, 120);  // aumenta um pouco pra ver
    // doc.addImage(mapImage, 'PNG', 20, 190, 50, 50);        // muda pra PNG se for PNG
    // doc.addImage(imovelImage, 'PNG', 20, 250, 50, 50);


    const fileName = 'Relatorio_Inicial_' + distrito + '_' + this.dataAtual() + ".pdf";
    doc.save(fileName);
  }

  static gerarCabecalho(doc, logoEsq, logoDir) {
      // Logo à esquerda
      if (logoEsq) {
          doc.addImage(logoEsq, "PNG", 10, 10, 30, 20);
      }

      // Logo à direita
      if (logoDir) {
          doc.addImage(logoDir, "PNG", 170, 10, 30, 15);
      }

      // Título central
      doc.setFontSize(14);
      doc.text("Relatório de informações gerais sobre as", doc.internal.pageSize.getWidth() / 2, 15, { align: "center" });
      doc.text("propriedades rurais cadastradas no censo agropecuário", doc.internal.pageSize.getWidth() / 2, 21, { align: "center" });

      // Informações extras
      doc.setFontSize(8);
      doc.text(`Data: ${new Date().toLocaleDateString()}`, 170, 28);

      // Linha divisória
      doc.setDrawColor(150);
      doc.line(10, 32, 200, 32);
  }

  static dataAtual(){
    const hoje = new Date();

    const data = hoje.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    });

    const formatada = data.replace(/\//g, "_");

    return  formatada;

  }

}

export default PdfInitialPage;
